'use strict';

DoohApps
    .factory('CompanyData', ['restApi', function (restApi) {
        var controllerName = 'Company/';

        return {
            getCompanyList: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompanyList');
            },
            getCompanyData: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompanyFilterData', objectFilterOptions);
            },
            updateCompany: function (successCallback, company) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutCompany', company);
            },
            addCompany: function (successCallback, company) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostCompany', company);
            },
            deleteCompany: function (successCallback, id) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteCompany?Id=' + id);
            },
            getAllCompanyList: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAllCompanyList');
            },
            companyDeleteCheck: function (successCallback, id) {
                restApi.GetApiMethod(successCallback, controllerName + 'CompanyDeleteCheck?id='+id);
            },
        }
    }]);
